import React from 'react';
import DownloadImageButton from 'src/shared/components/download-image-button/DownloadImageButton';
import useProject from 'src/shared/hooks/useProject';
import useEcologyHubAnalytics from 'src/app/ecology-hub/hooks/useEcologyHubAnalytics';

const StatisticalComparisonDownloadImageButton = (props: { chartContainer: React.RefObject<HTMLDivElement | null> }) => {
    const { currentProjectDetails } = useProject();
    const { trackStatisticalComparisonDownloadImageClick } = useEcologyHubAnalytics();

    const ignoreElements = (element: Element) => {
        // Hide elements
        const explainerIcon = element.hasAttribute('data-explainer-icon');
        const chartControls = element.id === 'chart-controls';
        return explainerIcon || chartControls;
    };

    const onClone = async (document: Document, element: Element) => {
        // Unhide element to display in the downloaded image
        const nmLogoSection = element.querySelector('#data-map-logo-section');
        const chartSubtitle = element.querySelector('#data-chart-subtitle');
        [nmLogoSection, chartSubtitle].forEach(element => {
            if (element) {
                element.classList.remove('hidden');
            }
        });

        // Increase top margin for legend section
        const legendSection = element.querySelector('.recharts-legend-wrapper') as HTMLDivElement;
        if (legendSection) {
            legendSection.style.top = '100px';
        }
    };

    return (
        <DownloadImageButton
            containerRef={props.chartContainer}
            downloadFileName={`NatureMetrics_${currentProjectDetails?.projectName}_Ecology_Hub_Statistical_Comparison.png`}
            scale={1.2}
            ignoreElements={ignoreElements}
            onClone={onClone}
            onClick={trackStatisticalComparisonDownloadImageClick}
        />
    );
};

export default StatisticalComparisonDownloadImageButton;
